/// <amd-module name="Artifacts/Root/Constants" />

/**
 * Common constants.
 */
export class CommonConstants {
  public static FeatureArea = "Packaging";
  public static MaxFeedNameLength = 64;
  public static FeedServiceInstanceId = "00000036-0000-8888-8000-000000000000";
  public static PackagingServiceInstanceId = "00000030-0000-8888-8000-000000000000";
  public static LastOpenedFeedLocalStorageKey = "lastFeed";
}

export enum ComponentStatus {
  Loading,
  Error,
  Ready,
}

/***
 * ComponentState maintains the current status and error message for a component.
 * Use ComponentStateSwitch component to render conditionally depending on the ComponentStatus value.
 */
export interface ComponentState {
  status: ComponentStatus;
  errorMessage?: string;
}

/**
 * Enumeration of available protocols.
 */
export enum Protocol {
  Npm = "npm",
  Nuget = "NuGet",
  Maven = "Maven",
  Pypi = "PyPI",
  UPack = "UPack",
  Ivy = "ivy",
  Cargo = "Cargo",
  Conda = "Conda",
}

export const FeedServiceInstanceId = "00000036-0000-8888-8000-000000000000";
export const TfsServiceInstanceId = "00025394-6065-48ca-87d9-7f5672854ef7";

export class RegistryConstants {
  public static MruFeedIdPath = "Packaging/MruFeedId";
}

export class CiConstants {
  public static Area = CommonConstants.FeatureArea;
  public static ConnectToFeedToolChange = "ConnectToFeedToolChange";
  public static DeprecatePackage = "NpmDeprecatePackage";
  public static ExternalLink = "ExternalLink";
  public static PersonUrlLinkClicked = "PersonUrlLinkClicked";
  public static PersonEmailLinkClicked = "PersonEmailLinkClicked";
}

/**
 * Perfomance scenario constants.
 */
export class PerfScenarios {
  public static Area = CommonConstants.FeatureArea;
  public static MultiplePackageVersionsDeprecated = "Package.Feed.PackagesMultiDeprecated";
  public static PackageVersionDeprecated = "Package.Feed.PackageDeprecated";
  public static MultiplePackageVersionsRestoredToFeed = "Package.Feed.PackagesRestoredToFeed";
  public static MultiplePackageVersionsPermanentDeleted = "Package.Feed.PackagesPermanentDeleted";
  public static RecycleBinPackageVersionRestore =
    "Packaging.Package.RecycleBinPackageVersionRestore";
  public static RecycleBinPackageVersionPermanentDelete =
    "Packaging.Package.RecycleBinPackageVersionPermanentDelete";
}

/**
 * Enumeration of all possible feed operation permissions
 */
export enum FeedOperationPermissions {
  None = 0,
  AdministerFeed = 1,
  ArchiveFeed = 2,
  DeleteFeed = 4,
  CreateFeed = 8,
  EditFeed = 16,
  ReadPackages = 32,
  AddPackage = 64,
  UpdatePackage = 128,
  DeletePackage = 256,
  // 512 used to be ModifyIndex, and some ACEs still exist with that bit set
  DelistPackage = 1024,
  AddUpstreamPackage = 2048,
  // 4096 was temporarily used in the past. These should have been reset.
}
